import makeStyles from '@mui/styles/makeStyles';
import { TourStyleTypes } from 'types';
import theme from '@monorepo/shared/src/themes/studentAppTheme';

export const bannerStyles = makeStyles((theme) => {
  return {
    welcome: {
      zIndex: 9998,
      position: 'absolute',
      top: '30vh',
      right: '50vw',
    },
    matManIcon: {
      zIndex: 9998,
      position: 'absolute',
      bottom: '50vh',
      left: '7vw',
    },
    letterBooks: {
      zIndex: 9998,
      position: 'absolute',
      top: 350,
      left: -30,
      [theme.breakpoints.down('md')]: {
        left: '10vh',
      },
    },
    assignments: {
      zIndex: 9998,
      position: 'absolute',
      top: '10vh',
      right: '4vw',
      [theme.breakpoints.down('md')]: {
        top: '40vh',
        right: '4vw',
      },
    },
    greatAlphabetParade: {
      zIndex: 9998,
      position: 'absolute',
      bottom: 100,
      left: 300,
    },
    rewards: {
      zIndex: 9998,
      position: 'absolute',
      top: '35vh',
      right: '10vw',
      [theme.breakpoints.down('md')]: {
        top: '25vh',
      },
    },
  };
});

export const matManImageStyles = makeStyles(() => {
  return {
    welcome: {
      zIndex: 9998,
      display: 'block',
      position: 'absolute',
      bottom: '28vh',
      right: '15vw',
      [theme.breakpoints.down('md')]: {
        bottom: '20vh',
      },
    },
    matManIcon: {
      zIndex: 9998,
      position: 'absolute',
      bottom: '20vh',
      left: '44vw',
      [theme.breakpoints.down('md')]: {
        bottom: '10vh',
      },
    },
    rewards: {
      zIndex: 9998,
      position: 'absolute',
      top: '30vh',
      right: '42vw',
      '-webkit-transform': 'scaleX(-1)',
      transform: 'scaleX(-1)',
      [theme.breakpoints.down('md')]: {
        top: '32vh',
        right: '46vw',
      },
    },
  };
});

export const arrowStyles = makeStyles((theme) => {
  return {
    welcome: {
      zIndex: 9998,
      position: 'absolute',
      bottom: 50,
      right: 100,
      [theme.breakpoints.down('md')]: {
        '-webkit-transform': 'rotate(20deg)',
        transform: 'rotate(20deg)',
        bottom: 20,
      },
    },
    matManIcon: {
      zIndex: 9998,
      position: 'absolute',
      bottom: '10vh',
      left: 150,
      '-webkit-transform': 'scaleX(-1) rotate(80deg)',
      transform: 'scaleX(-1) rotate(80deg)',
    },
    letterBooks: {
      zIndex: 9998,
      position: 'absolute',
      top: 300,
      left: 500,
      '-webkit-transform': 'rotate(-90deg)',
      transform: 'rotate(-90deg)',
    },
    assignments: {
      zIndex: 9998,
      position: 'absolute',
      top: 350,
      width: '215px',
    },
    greatAlphabetParade: {
      zIndex: 9998,
      position: 'absolute',
      top: 0,
      left: 350,
      width: '215px',
      '-webkit-transform': 'scaleX(-1) rotate(60deg)',
      transform: 'scaleX(-1) rotate(-90deg)',
    },
    rewards: {
      zIndex: 9998,
      position: 'absolute',
      top: 50,
      right: 125,
      width: '215px',
      '-webkit-transform': 'scaleY(-1) rotate(70deg)',
      transform: 'scaleY(-1) rotate(70deg)',
      [theme.breakpoints.down('md')]: {
        '-webkit-transform': 'scaleY(-1) rotate(60deg)',
        transform: 'scaleY(-1) rotate(60deg)',
        top: '3vh',
      },
    },
  };
});

export const stepToStyleMapper = (item, step) => {
  if (item === TourStyleTypes.BANNER) return bannerStyles(theme)[step];
  if (item === TourStyleTypes.MATMANIMAGE) return matManImageStyles(theme)[step];
  if (item === TourStyleTypes.ARROW) return arrowStyles(theme)[step];
};
